/**
 * Polyfill / refuerzo para <details name="..."> exclusivos.
 * Los details con data-collapsible-open-default no entran al grupo.
 */
(() => {
  if (window.__olivineCollapsibleAccordionBound) return;
  window.__olivineCollapsibleAccordionBound = true;

  const testDetails = document.createElement('details');
  const supportsNativeName = 'name' in testDetails;

  const getNamedSiblings = (details) => {
    const name = details.getAttribute('name');
    if (!name) return [];
    return Array.from(
      document.querySelectorAll('details.main-product-container-info-collapsible[name]')
    ).filter(
      (el) =>
        el !== details &&
        el.getAttribute('name') === name &&
        !el.hasAttribute('data-collapsible-open-default')
    );
  };

  const onToggle = (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.open) return;
    if (details.hasAttribute('data-collapsible-open-default')) return;
    if (!details.getAttribute('name')) return;

    getNamedSiblings(details).forEach((other) => {
      if (other.open) other.open = false;
    });
  };

  // Nativo en browsers modernos; el listener cubre Safari viejos y edge cases.
  document.addEventListener('toggle', onToggle, true);

  // Si el browser ya cierra hermanos por `name`, cerrar dos veces no hace daño.
  // Flag solo por claridad en debug.
  window.__olivineCollapsibleAccordionNativeName = supportsNativeName;
})();
